import React from 'react';
import PropTypes from 'prop-types';
import {  makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {ItemContacto} from './ItemContacto'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Tooltip, Typography } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { traerContactosConfirmados, traerContactosPendientes, traerContactosWeb } from '../../actions/contactosWeb/contactos';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'cuil', numeric: false, disablePadding: true, label: 'Cuil' },
  { id: 'apellido_y_nombre', numeric: true, disablePadding: false, label: 'Nombre Completo' },
  { id: 'domicilioAfiliados.nro', numeric: true, disablePadding: false, label: 'Dirección' },
  { id: 'email', numeric: true, disablePadding: false, label: 'Email' },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  switchBase1:{
    color: 'white',
    '&$checked': {
        transform: 'translateX(16px)',
        color: '#2e7d32',
        '& + $track': {
          backgroundColor: '#66bb6a',
          opacity: 1,
          border: 'none',
        },
      },
  },
  switchBase2:{
    color: 'white',
    '&$checked': {
        transform: 'translateX(16px)',
        color: '#ffc107',
        '& + $track': {
          backgroundColor: '#B7A931',
          opacity: 1,
          border: 'none',
        },
      },
  },
  checked:{},
  track: {},
  typography:{
    color:'white',
    marginLeft:5
  }
}));

export const  ListaContactos = () => {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [validos, setValidos] = React.useState(false);
  const [pendiente, setPendiente] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const {items} = useSelector((state)=> state.contactosWeb)
  const dispatch = useDispatch();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  const handleChangeValido = (event) => {
    if(event.target.checked){
      dispatch(traerContactosConfirmados());
    }else{
      dispatch(traerContactosWeb());
    }
    setValidos(event.target.checked);
  };
  const handleChangePendiente = (event) => {
    if(event.target.checked){
      dispatch(traerContactosPendientes());
    }else{
      dispatch(traerContactosWeb());
    }
    setPendiente(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  return (
    <div className={classes.root}>
      <Grid container direction="row">
        <Grid item lg={3}>
          <FormControlLabel
            control={<Switch checked={dense} onChange={handleChangeDense} color="primary"/>}
            label="Minimizar"
            style={{margin:7,color:'white'}}
            />
        </Grid>
        <Grid container alignItems="center" lg={3}>
            <Tooltip title='Contacto mail confirmado' placement="right-end"><CheckCircleOutlineIcon style={{color:'green'}}/></Tooltip>
            <Typography classes={{root:classes.typography}}>Mail confirmado</Typography>
            <FormControlLabel
              control={<Switch checked={validos} onChange={handleChangeValido} classes={{switchBase:classes.switchBase1,checked:classes.checked,track:classes.track}}/>}
              style={{margin:7,color:'white'}}
              />
        </Grid>
        <Grid container alignItems="center" lg={3}>
            <Tooltip title='Contacto mail pendiente' placement="right-end"><ErrorOutlineIcon style={{color:'#ffc107'}}/></Tooltip>
            <Typography classes={{root:classes.typography}}>Pendiente confirmar mail</Typography>
            <FormControlLabel
              control={<Switch checked={pendiente} onChange={handleChangePendiente} classes={{switchBase:classes.switchBase2,checked:classes.checked,track:classes.track}}/>}
              style={{margin:7,color:'white'}}
              />
        </Grid>
      </Grid>
      
      <Paper className={classes.paper}>
        <TableContainer>
            {items.length !== 0? 
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              onRequestSort={handleRequestSort}
              rowCount={items.length}
            />
            <TableBody>
              {stableSort(items, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  
                  return (
                    <ItemContacto 
                        row={row}
                        handleClick={handleClick}
                        index={index}
                        isSelected={isSelected}
                    />
                  );
                })}
            </TableBody>
          </Table> :
          <Grid container justify="center" style={{margin:20}}><Typography variant="h2" component="h2" >Sin Datos. . . </Typography></Grid> 
        }
        </TableContainer>
        {items.length !== 0&&<TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={items.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage={'Contactos por pag.'}
        />}
      </Paper>
    </div>
  );
}
